import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ActiveInactiveItineraryFacility,
  createItineraryFacility,
  deleteItineraryFacility,
  getAllActiveItineraryFacility,
  getAllItineraryFacility,
  getItineraryFacilityByID,
  itineraryFacilityImageUpload,
  updateItineraryFacility,
} from "./services/itineraryfacility.services";
import {
  IItinearyFacilityInitialState,
  IItineraryFacility,
} from "./itineraryfacilityModel";

const initialState: IItinearyFacilityInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  ItinearyFacilityList: [],
  ItineraryFacilityID: null,
  ItinearyFacilityDetail: {
    Name: "",
    FacilityImage: "",
    IsActive: 1,
  },
};

const itineraryfacilitySlice = createSlice({
  name: "itinearyfacility",
  initialState,
  reducers: {
    clearItinearyFacilityDetails: (state) => {
      state.ItinearyFacilityDetail = initialState.ItinearyFacilityDetail;
    },
    setItinearyFacilityID: (state, action) => {
      state.ItineraryFacilityID = action.payload;
    },
    clearItinearyFacilityID: (state) => {
      state.ItineraryFacilityID = initialState.ItineraryFacilityID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllItineraryFacility.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllItineraryFacility.fulfilled,
      (state, action: PayloadAction<IItineraryFacility[]>) => {
        state.loading = false;
        state.ItinearyFacilityList = action.payload || [];
      }
    );
    builder.addCase(getAllItineraryFacility.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ItinearyFacilityList = [];
    });
    builder.addCase(createItineraryFacility.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createItineraryFacility.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createItineraryFacility.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateItineraryFacility.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateItineraryFacility.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateItineraryFacility.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteItineraryFacility.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteItineraryFacility.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteItineraryFacility.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getItineraryFacilityByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(
      getItineraryFacilityByID.fulfilled,
      (state, action: any) => {
        state.formLoading = false;
        state.ItinearyFacilityDetail = action.payload;
      }
    );
    builder.addCase(getItineraryFacilityByID.rejected, (state, action) => {
      state.formLoading = false;
      state.ItinearyFacilityDetail = initialState.ItinearyFacilityDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveItineraryFacility.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveItineraryFacility.fulfilled,
      (state, action: PayloadAction<IItineraryFacility[]>) => {
        state.loading = false;
        state.ItinearyFacilityList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveItineraryFacility.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ItinearyFacilityList = [];
    });
    builder.addCase(ActiveInactiveItineraryFacility.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveItineraryFacility.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(
      ActiveInactiveItineraryFacility.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      }
    );

    builder.addCase(itineraryFacilityImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(itineraryFacilityImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(itineraryFacilityImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearItinearyFacilityDetails,
  clearItinearyFacilityID,
  setItinearyFacilityID,
} = itineraryfacilitySlice.actions;
export default itineraryfacilitySlice.reducer;
